import React from 'react'
import { Tab as TabBS } from 'react-bootstrap';

interface TabsProps {
    eventKey: string
    title: string
    tabClassName?: string
}

const Tab: React.FC<TabsProps> = ({ eventKey, title, tabClassName, children }) => {
    return (
        <TabBS eventKey={eventKey} title={title} tabClassName={tabClassName}>
            {children}
        </TabBS>
    );
}

export default Tab